import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  boxApply1qmzdb3dh90hg as boxApply,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import { AbstractCollection1g9uvtcheckwb as AbstractCollection } from './AbstractCollection.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { KtList3hktaavzmj137 as KtList } from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SubListClass;
function SubList() {
  if (SubListClass === VOID) {
    class $ extends AbstractList() {
      static ek(list, fromIndex, toIndex) {
        var $this = this.ti();
        $this.bk_1 = list;
        $this.ck_1 = fromIndex;
        $this.dk_1 = 0;
        Companion_instance.r5($this.ck_1, toIndex, $this.bk_1.p1());
        $this.dk_1 = toIndex - $this.ck_1 | 0;
        return $this;
      }
      q1(index) {
        Companion_instance.f7(index, this.dk_1);
        return this.bk_1.q1(this.ck_1 + index | 0);
      }
      p1() {
        return this.dk_1;
      }
      m3(fromIndex, toIndex) {
        Companion_instance.r5(fromIndex, toIndex, this.dk_1);
        return SubList().ek(this.bk_1, this.ck_1 + fromIndex | 0, this.ck_1 + toIndex | 0);
      }
    }
    initMetadataForClass($, 'SubList', VOID, VOID, [AbstractList(), RandomAccess()]);
    SubListClass = $;
  }
  return SubListClass;
}
var IteratorImplClass;
function IteratorImpl() {
  if (IteratorImplClass === VOID) {
    class $ {
      constructor($outer, $box) {
        boxApply(this, $box);
        this.gk_1 = $outer;
        this.fk_1 = 0;
      }
      n1() {
        return this.fk_1 < this.gk_1.p1();
      }
      o1() {
        if (!this.n1())
          throw NoSuchElementException().y1();
        var _unary__edvuaz = this.fk_1;
        this.fk_1 = _unary__edvuaz + 1 | 0;
        return this.gk_1.q1(_unary__edvuaz);
      }
    }
    initMetadataForClass($, 'IteratorImpl');
    IteratorImplClass = $;
  }
  return IteratorImplClass;
}
var ListIteratorImplClass;
function ListIteratorImpl() {
  if (ListIteratorImplClass === VOID) {
    class $ extends IteratorImpl() {
      constructor($outer, index, $box) {
        if ($box === VOID)
          $box = {};
        $box.jk_1 = $outer;
        super($outer, $box);
        Companion_instance.u6(index, this.jk_1.p1());
        this.fk_1 = index;
      }
      v6() {
        return this.fk_1 > 0;
      }
      w6() {
        return this.fk_1;
      }
      x6() {
        if (!this.v6())
          throw NoSuchElementException().y1();
        this.fk_1 = this.fk_1 - 1 | 0;
        return this.jk_1.q1(this.fk_1);
      }
      y6() {
        return this.fk_1 - 1 | 0;
      }
    }
    initMetadataForClass($, 'ListIteratorImpl');
    ListIteratorImplClass = $;
  }
  return ListIteratorImplClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.q5_1 = 2147483639;
      }
      f7(index, size) {
        if (index < 0 || index >= size) {
          throw IndexOutOfBoundsException().je('index: ' + index + ', size: ' + size);
        }
      }
      u6(index, size) {
        if (index < 0 || index > size) {
          throw IndexOutOfBoundsException().je('index: ' + index + ', size: ' + size);
        }
      }
      r5(fromIndex, toIndex, size) {
        if (fromIndex < 0 || toIndex > size) {
          throw IndexOutOfBoundsException().je('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size);
        }
        if (fromIndex > toIndex) {
          throw IllegalArgumentException().a1('fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
        }
      }
      eh(startIndex, endIndex, size) {
        if (startIndex < 0 || endIndex > size) {
          throw IndexOutOfBoundsException().je('startIndex: ' + startIndex + ', endIndex: ' + endIndex + ', size: ' + size);
        }
        if (startIndex > endIndex) {
          throw IllegalArgumentException().a1('startIndex: ' + startIndex + ' > endIndex: ' + endIndex);
        }
      }
      va(oldCapacity, minCapacity) {
        var newCapacity = oldCapacity + (oldCapacity >> 1) | 0;
        if ((newCapacity - minCapacity | 0) < 0)
          newCapacity = minCapacity;
        if ((newCapacity - 2147483639 | 0) > 0)
          newCapacity = minCapacity > 2147483639 ? 2147483647 : 2147483639;
        return newCapacity;
      }
      i7(c) {
        var hashCode_0 = 1;
        var _iterator__ex2g4s = c.m1();
        while (_iterator__ex2g4s.n1()) {
          var e = _iterator__ex2g4s.o1();
          var tmp = imul(31, hashCode_0);
          var tmp1_elvis_lhs = e == null ? null : hashCode(e);
          hashCode_0 = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
        }
        return hashCode_0;
      }
      h7(c, other) {
        if (!(c.p1() === other.p1()))
          return false;
        var otherIterator = other.m1();
        var _iterator__ex2g4s = c.m1();
        while (_iterator__ex2g4s.n1()) {
          var elem = _iterator__ex2g4s.o1();
          var elemOther = otherIterator.o1();
          if (!equals(elem, elemOther)) {
            return false;
          }
        }
        return true;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var AbstractListClass;
function AbstractList() {
  if (AbstractListClass === VOID) {
    class $ extends AbstractCollection() {
      static ti($box) {
        return this.j6($box);
      }
      m1() {
        return new (IteratorImpl())(this);
      }
      s1(element) {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.indexOfFirst' call
          var index = 0;
          var _iterator__ex2g4s = this.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            if (equals(item, element)) {
              tmp$ret$1 = index;
              break $l$block;
            }
            index = index + 1 | 0;
          }
          tmp$ret$1 = -1;
        }
        return tmp$ret$1;
      }
      u1(index) {
        return new (ListIteratorImpl())(this, index);
      }
      m3(fromIndex, toIndex) {
        return SubList().ek(this, fromIndex, toIndex);
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(!(other == null) ? isInterface(other, KtList()) : false))
          return false;
        return Companion_instance.h7(this, other);
      }
      hashCode() {
        return Companion_instance.i7(this);
      }
    }
    initMetadataForClass($, 'AbstractList', VOID, VOID, [AbstractCollection(), KtList()]);
    AbstractListClass = $;
  }
  return AbstractListClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instanceovl8he3jiijf,
  AbstractList as AbstractList3ck35puwbp1e9,
};
//endregion

//# sourceMappingURL=AbstractList.mjs.map
